<template>
  <section>
    <SlideShowTop />

    <div :style="isMobile ? '' : 'margin: auto; width: 80%;'">
      <h1 style="font-size: 25px !important; margin-top: 20px">{{ $store.getVaquejadasLength === 0 ? 'Não há vaquejadas disponíveis no momento' : 'Vaquejadas Disponíveis' }}</h1>
      <div :style="isMobile ? 'width: 100%' : 'display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-evenly'">
        <article v-for="(vaquejada, i) in vaquejadas" :key="i" style="margin-bottom: 10px;" :style="isMobile ? 'width: 100%' : 'width: 350px'">
          <VaquejadaCard
            :id="vaquejada.id"
            :nome="vaquejada.nome"
            :data-inicio="vaquejada.dataInicio"
            :data-fim="vaquejada.dataFim"
            :limite-senhas-vaqueiro="vaquejada.limiteSenhasVaqueiro"
            :cidade="vaquejada.city"
            :categorias="vaquejada.categorias"
            :valor-boi="vaquejada.valorBoi"
            :quantidade-senhas="vaquejada.diasSenhas.reduce((a: any, b: any) => a + b.quantidade, 0)"
            :logo="vaquejada.logo ?? ''"
            :quantidade-dias="vaquejada.diasSenhas.length"
          />
        </article>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
  import VaquejadaCard from '@/components/ListarVaquejadasPage/VaquejadaCard.vue'

  export default {
    name: 'ListarVaquejadasPage',
    components: { VaquejadaCard },
    data: () => ({
      vaquejadas: [],
    }),
    methods: {
      async list() {
        try {
          const response = await this.axios.get('vaquejadas', {
            params: {
              includeCity: 'true',
              pagina: 1,
              perPage: 10,
              onlyActives: 'true',
              feed: 'true'
            },
          });
          this.vaquejadas = response.data.vaquejadas;
          this.$store.setVaquejadasLength(response.data.vaquejadas.length);
        } catch (error) {
          console.error(error);
        }
      }
    },
    async created() {
      await this.list();
    },
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile;
      }
    }
  }
</script>

<style scoped>

</style>
